<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title">এ্যাসেসমেন্ট আবেদন ফরম</h1>
        <p class="page-subtitle">নতুন এ্যাসেসমেন্ট তৈরি করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" routerLink="/admin/multiple-assessment-create" class="btn-secondary-modern">
          <i class="fas fa-plus-square"></i>
          একাধিক এ্যাসেসমেন্ট
        </button>
      </div>
    </div>
  </div>

  <!-- Main Form -->
  <div class="content-grid">
    <form *ngIf="assesmentFrom" [formGroup]="assesmentFrom" (ngSubmit)="onSubmit()" class="modern-form">
      
      <!-- Basic Information Section -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-info-circle"></i>
            মৌলিক তথ্য
          </h3>
        </div>
        
        <div class="card-body">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label required">ওয়ার্ড নং *</label>
              <select name="ward_number" formControlName="ward_number" 
                      class="form-control"
                      [class.is-invalid]="assesmentFrom.get('ward_number')?.invalid && assesmentFrom.get('ward_number')?.touched">
                <option value="0">যে কোন একটি সিলেক্ট করুন</option>
                <option *ngFor="let ward of wardList" [value]="ward.ward_number">
                  {{ward.ward_name}}
                </option>
              </select>
              <div *ngIf="assesmentFrom.get('ward_number')?.invalid && assesmentFrom.get('ward_number')?.touched" class="invalid-feedback">
                অনুগ্রহ করে একটি ওয়ার্ড নির্বাচন করুন
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label required">হোল্ডিং নং *</label>
              <input 
                type="text" 
                name="holdingNo" 
                formControlName="holding_number" 
                class="form-control"
                [class.is-invalid]="assesmentFrom.get('holding_number')?.invalid && assesmentFrom.get('holding_number')?.touched"
                placeholder="হোল্ডিং নং">
              <div *ngIf="assesmentFrom.get('holding_number')?.invalid && assesmentFrom.get('holding_number')?.touched" class="invalid-feedback">
                অনুগ্রহ করে হোল্ডিং নং লিখুন
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label required">আবেদনকারীর নাম *</label>
              <input 
                type="text" 
                name="requestedPersonName" 
                formControlName="name" 
                class="form-control"
                [class.is-invalid]="assesmentFrom.get('name')?.invalid && assesmentFrom.get('name')?.touched"
                placeholder="আবেদনকারীর নাম">
              <div *ngIf="assesmentFrom.get('name')?.invalid && assesmentFrom.get('name')?.touched" class="invalid-feedback">
                অনুগ্রহ করে আবেদনকারীর নাম লিখুন
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label">পিতা/স্বামী</label>
              <input 
                type="text" 
                name="fatherOrHusbandName" 
                formControlName="gurdian_name" 
                class="form-control" 
                placeholder="পিতা/স্বামী">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label required">মোবাইল নং *</label>
              <input 
                type="text" 
                name="phoneNumber" 
                formControlName="mobile_number" 
                class="form-control"
                [class.is-invalid]="assesmentFrom.get('mobile_number')?.invalid && assesmentFrom.get('mobile_number')?.touched"
                placeholder="মোবাইল নং">
              <div *ngIf="assesmentFrom.get('mobile_number')?.invalid && assesmentFrom.get('mobile_number')?.touched" class="invalid-feedback">
                অনুগ্রহ করে মোবাইল নং লিখুন
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label">আইডি নং</label>
              <input 
                type="text" 
                name="nidNumber" 
                formControlName="id_number" 
                class="form-control" 
                placeholder="আইডি নং">
            </div>
          </div>
        </div>
      </div>

      <!-- Allowance and Profession Section -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-briefcase"></i>
            ভাতা ও পেশা
          </h3>
        </div>
        
        <div class="card-body">
          <div class="form-group">
            <label class="form-label required">ভাতা *</label>
            <div class="radio-group">
              <div *ngFor="let vata of vataList" class="radio-item">
                <input 
                  type="radio" 
                  formControlName="vata" 
                  [value]="vata.key.toString()" 
                  name="vata" 
                  [id]="'vata-' + vata.key"
                  class="radio-input"
                  [class.is-invalid]="assesmentFrom.get('vata')?.invalid && assesmentFrom.get('vata')?.touched">
                <label [for]="'vata-' + vata.key" class="radio-label">{{vata.value}}</label>
              </div>
            </div>
            <div *ngIf="assesmentFrom.get('vata')?.hasError('required') && assesmentFrom.get('vata')?.touched" class="invalid-feedback">
              অনুগ্রহ করে ভাতার একটি অপশন নির্বাচন করুন
            </div>
          </div>

          <div class="form-group">
            <label class="form-label required">পেশা *</label>
            <div class="radio-group">
              <div *ngFor="let profession of professionList" class="radio-item">
                <input 
                  type="radio" 
                  formControlName="pesha" 
                  [value]="profession.key.toString()" 
                  name="pesha" 
                  [id]="'profession-' + profession.key"
                  class="radio-input"
                  [class.is-invalid]="assesmentFrom.get('pesha')?.invalid && assesmentFrom.get('pesha')?.touched">
                <label [for]="'profession-' + profession.key" class="radio-label">{{profession.value}}</label>
              </div>
            </div>
            <div *ngIf="assesmentFrom.get('pesha')?.hasError('required') && assesmentFrom.get('pesha')?.touched" class="invalid-feedback">
              অনুগ্রহ করে পেশার একটি অপশন নির্বাচন করুন
            </div>
          </div>
        </div>
      </div>

      <!-- Household Information Section -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-home"></i>
            খানার বিবরণ
          </h3>
        </div>
        
        <div class="card-body">
          <div class="form-group">
            <label class="form-label required">খানার ধরণ *</label>
            <div class="radio-group">
              <div *ngFor="let khana of khanaList" class="radio-item">
                <input 
                  type="radio" 
                  formControlName="khanar_dhoron" 
                  [value]="khana.key.toString()" 
                  name="khanar_dhoron" 
                  [id]="'khana-' + khana.key"
                  class="radio-input"
                  [class.is-invalid]="assesmentFrom.get('khanar_dhoron')?.invalid && assesmentFrom.get('khanar_dhoron')?.touched"
                  (change)="changeKhanarDhoron(khana.key)">
                <label [for]="'khana-' + khana.key" class="radio-label">{{khana.value}}</label>
              </div>
            </div>
            <div *ngIf="assesmentFrom.get('khanar_dhoron')?.invalid && assesmentFrom.get('khanar_dhoron')?.touched" class="invalid-feedback">
              অনুগ্রহ করে খানার ধরণের একটি অপশন নির্বাচন করুন
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label required">খানার আনুমানিক মূল্য *</label>
              <input 
                type="text" 
                name="khanar_anumanik_mullo" 
                formControlName="khanar_anumanik_mullo" 
                class="form-control"
                [class.is-invalid]="assesmentFrom.get('khanar_anumanik_mullo')?.invalid && assesmentFrom.get('khanar_anumanik_mullo')?.touched"
                placeholder="খানার আনুমানিক মূল্য">
              <div *ngIf="assesmentFrom.get('khanar_anumanik_mullo')?.invalid && assesmentFrom.get('khanar_anumanik_mullo')?.touched" class="invalid-feedback">
                অনুগ্রহ করে খানার আনুমানিক মূল্য লিখুন
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label required">ধার্যকৃত কর *</label>
              <input 
                type="text" 
                name="khanar_dharjokrito_kor" 
                formControlName="khanar_dharjokrito_kor" 
                class="form-control"
                [class.is-invalid]="assesmentFrom.get('khanar_dharjokrito_kor')?.invalid && assesmentFrom.get('khanar_dharjokrito_kor')?.touched"
                placeholder="ধার্যকৃত কর">
              <div *ngIf="assesmentFrom.get('khanar_dharjokrito_kor')?.invalid && assesmentFrom.get('khanar_dharjokrito_kor')?.touched" class="invalid-feedback">
                অনুগ্রহ করে ধার্যকৃত কর লিখুন
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Address Section -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-map-marker-alt"></i>
            ঠিকানা
          </h3>
        </div>
        
        <div class="card-body">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">গ্রাম/রাস্তা</label>
              <input 
                type="text" 
                name="village" 
                formControlName="gram_or_rasta" 
                class="form-control" 
                placeholder="গ্রাম/রাস্তা">
            </div>
            
            <div class="form-group">
              <label class="form-label">পোস্ট অফিস</label>
              <input 
                type="text" 
                name="postOffice" 
                formControlName="post_office" 
                class="form-control" 
                placeholder="পোস্ট অফিস">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">উপজেলা</label>
              <input 
                type="text" 
                name="upozilla" 
                formControlName="upozilla" 
                class="form-control" 
                placeholder="উপজেলা">
            </div>
            
            <div class="form-group">
              <label class="form-label">জেলা</label>
              <input 
                type="text" 
                name="zilla" 
                formControlName="zilla" 
                class="form-control" 
                placeholder="জেলা">
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="content-card">
        <div class="card-body">
          <div class="form-actions">
            <button type="button" class="btn-secondary-modern" routerLink="/admin/assessment-page">
              <i class="fas fa-times"></i>
              বাতিল
            </button>
            <button type="submit" class="btn-primary-modern">
              <i class="fas fa-save"></i>
              দাখিল করুন
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>